import React from 'react';
import classnames from 'classnames';
import RequiredField from '../RequiredField';

type Co2ToggleProps = {
    id?: string;
    label?: React.ReactNode;
    checked: boolean;
    onChange: (checked: boolean) => void;
    readOnly?: boolean;
    disabled?: boolean;
    showRequiredSymbol?: boolean;
    invalid?: boolean;
    className?: string;
    showText?: boolean;
    onText?: string;
    offText?: string;
};

const Co2Toggle = ({
    id,
    label,
    checked,
    onChange,
    readOnly = false,
    disabled = false,
    showRequiredSymbol = false,
    invalid = false,
    className,
    showText = true,
    onText = 'Yes',
    offText = 'No',
}: Co2ToggleProps) => {
    const isDisabled = readOnly || disabled;
    const controlHeight = 'calc(1.5em + 0.9rem + 2px)';

    return (
        <div className={classnames('d-flex flex-column', className)}>
            {label && (
                <label
                    htmlFor={id}
                    className={classnames('form-label text-body mb-1', { 'text-danger': invalid })}
                    style={{ lineHeight: 1.2 }}
                >
                    {label}
                    {showRequiredSymbol && <RequiredField />}
                </label>
            )}
            <button
                id={id}
                type="button"
                role="switch"
                aria-checked={checked}
                disabled={isDisabled}
                className={classnames('form-control position-relative bg-checkbox', {
                    //'border-success bg-checkbox': checked,
                    'border-danger': invalid,
                    'form-control-readOnly': readOnly,
                    'd-inline-flex align-self-start w-auto px-2 py-0': showText,
                    'p-0': !showText,
                })}
                style={{
                    width: showText ? 'auto' : 72,
                    height: controlHeight,
                    minHeight: controlHeight,
                    marginTop: 2,
                    borderRadius: 5,
                    cursor: isDisabled ? 'default' : 'pointer',
                }}
                onClick={() => {
                    if (!isDisabled) onChange(!checked);
                }}
            >
                {showText ? (
                    <span className="d-inline-flex align-items-center gap-2">
                        {checked && (
                            <span className="position-relative d-inline-block text-body">
                                <span className="invisible">{onText.length >= offText.length ? onText : offText}</span>
                                <span className="position-absolute top-0 start-0">{onText}</span>
                            </span>
                        )}
                        <i
                            className={classnames('fa', checked ? 'fa-regular fa-square-check text-success' : 'fa-regular fa-square-check text-danger')}
                            style={{ fontSize: 20, lineHeight: 1 }}
                        />
                        {!checked && (
                            <span className="position-relative d-inline-block text-body">
                                <span className="invisible">{onText.length >= offText.length ? onText : offText}</span>
                                <span className="position-absolute top-0 start-0">{offText}</span>
                            </span>
                        )}
                    </span>
                ) : (
                    <span
                        className="position-absolute d-inline-flex align-items-center justify-content-center"
                        aria-hidden="true"
                        style={{
                            width: 24,
                            height: 24,
                            left: checked ? 41 : 7,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            transition: 'left 160ms ease',
                        }}
                    >
                        <i
                            className={classnames('fa', checked ? 'fa-solid fa-square-check text-success' : 'fa-regular fa-square text-secondary')}
                            style={{ fontSize: 20, lineHeight: 1 }}
                        />
                    </span>
                )}
            </button>
        </div>
    );
};

export default Co2Toggle;
